import React, { useRef, useEffect, useState } from 'react';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import 'leaflet-routing-machine';
import '../map.css';
import axios from 'axios';
import { colors } from '../color';
import { PlusOutlined } from '@ant-design/icons';
import { FaCrosshairs } from 'react-icons/fa';
import { ServerIP } from '../component/ServerIP';





const ClientHomeMap = () => {

    //Map

    const mapContainer = useRef(null);
    const map = useRef(null);
    const center = { lat: 18.6565184, lng: -72.3156992 };
    const [location, setLocation] = useState([]);


    const [zoom] = useState(12);


    useEffect(() => {
        if (map.current) return;

        map.current = new L.Map(mapContainer.current, {
            center: L.latLng(center.lat, center.lng),
            zoom: zoom,
            zoomControl: false,
            minZoom: 3,
        });


        L.tileLayer('https://api.maptiler.com/maps/streets-v2/style.json?key=wpyZbJOc6hFpTL8ANsqV', {
            // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 20,
            minZoom: 3,
        }).addTo(map.current);

        //fetchNearbyMarker();

    }, [center.lat, center.lng, zoom]);

    //Alert

    const userMarkerRef = useRef(null);
    const [alertMarker, setAlertMarker] = useState([]);

    function getColor(title) {
        switch (title) {
            case 'Tir':
                return 'rgba(255,0,0,0.5)';
            case 'Kidnapping':
                return 'rgba(230, 126, 34, 0.5)';
            case 'Blocked':
                return 'gray';
            default:
                return 'black';
        }
    }

    function getIcon(title) {
        switch (title) {
            case 'Tir':
                return L.icon({ iconUrl: require('../data/IconImageMap/gun.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Kidnapping':
                return L.icon({ iconUrl: require('../data/IconImageMap/child.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            case 'Blocked':
                return L.icon({ iconUrl: require('../data/IconImageMap/block1.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
            default:
                return L.icon({ iconUrl: require('../data/IconImageMap/block.png'), iconSize: [25, 36], iconAnchor: [12, 41] });
        }
    }

    function getRadius(title) {
        switch (title) {
            case 'Tir':
                return 400;
            case 'Kidnapping':
                return 600;
            case 'Blocked':
                return 100;
            default:
                return 100;
        }
    }

    const markersRef = useRef([]);
    const circlesRef = useRef([]);

    useEffect(() => {
        if (Array.isArray(alertMarker) && alertMarker.length > 0) {
            // Supprimez les anciens marqueurs et cercles
            markersRef.current.forEach(marker => marker.remove());
            circlesRef.current.forEach(circle => circle.remove());

            // Réinitialisez les tableaux
            markersRef.current = [];
            circlesRef.current = [];

            alertMarker.map((marker, index) => {
                if (marker.coordinate) {
                    const icon = getIcon(marker.title);
                    const markerInstance = L.marker([marker.coordinate.latitude, marker.coordinate.longitude], { icon }).addTo(map.current);
                    markerInstance.bindPopup(`${marker.title} - ${getTime(marker.createdAt)}`);

                    markerInstance.on('click', () => {
                        map.current.flyTo([marker.coordinate.latitude, marker.coordinate.longitude] , map.current.getZoom());
                    });

                    const circle = L.circle([marker.coordinate.latitude, marker.coordinate.longitude], { radius: getRadius(marker.title), fillColor: getColor(marker.title), fillOpacity: 0.2, color: getColor(marker.title) }).addTo(map.current);

                    // Ajoutez les instances de marqueurs et de cercles aux tableaux
                    markersRef.current.push(markerInstance);
                    circlesRef.current.push(circle);
                }
            });
        }
    }, [alertMarker]);


    const fetchNearbyMarker = async () => {

        await axios.get(`${ServerIP}/alert/getAlert`)
            .then(res => {
                setAlertMarker(res.data.alertMarker)
            })
    };


    const getTime = (time) => {
        var date = new Date(time);
        var maintenant = new Date();
        var difference = Math.abs(maintenant - date); // en millisecondes

        var minutes = Math.floor(difference / 60000);
        if (minutes < 60) {
            return minutes + " min";
        } else {
            var heures = Math.floor(minutes / 60);
            return heures + " h";
        }

    };


    //Coordinate
    const firstCallRef = useRef(true);
    const intervalIdRef = useRef(null);

    useEffect(() => {

        intervalIdRef.current = setInterval(getRealTimePosition, 5000);

        return () => {
            if (intervalIdRef.current) {
                clearInterval(intervalIdRef.current);
            }
        };

    }, []);

    const getRealTimePositionFunc = async () => {
        intervalIdRef.current = setInterval(getRealTimePosition, 5000);

        if (!map.current.getCenter().equals([location[0], location[1]]) && firstCallRef.current === false) {
            map.current.flyTo([location[0], location[1]], map.current.getZoom());
        }
    }

    const circleRef = useRef(null);
    const circleRef2 = useRef(null);

 const getRealTimePosition = async () => {
    try {
        const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                resolve,
                reject,
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0,
                }
            );
        });

        const { latitude, longitude } = position.coords;
        setLocation([latitude, longitude]);

        const userIcon = L.icon({
            iconUrl: require('../data/IconImageMap/currentLocation.png'),
            iconSize: [25, 36],
            iconAnchor: [12, 36],
        });

        // Ajouter ou mettre à jour le marqueur
        if (!userMarkerRef.current) {
            userMarkerRef.current = L.marker([latitude, longitude], { icon: userIcon }).addTo(map.current);
        } else {
            userMarkerRef.current.setLatLng([latitude, longitude]);
        }

        // Ajouter ou mettre à jour le cercle
        if (!circleRef.current) {
            circleRef.current = L.circle([latitude, longitude], {
                radius: 3000,
                fillColor: colors.accent,
                fillOpacity: 0.2,
                color: 'transparent',
                weight: 0  
            }).addTo(map.current);
        } else {
            circleRef.current.setLatLng([latitude, longitude]); // Mise à jour de la position
        }

         //if (!circleRef2.current) {
           // circleRef2.current = L.circle([latitude, longitude], {
             //   radius: 1500,
             //   fillColor: colors.accent,
              //  fillOpacity: 0.2,
               // color: 'transparent',
             //   weight: 0  
          //  }).addTo(map.current);
      //  } else {
            //circleRef2.current.setLatLng([latitude, longitude]); // Mise à jour de la position
        //}

        // Centrer la carte uniquement lors du premier appel
        if (firstCallRef.current) {
            map.current.flyTo([latitude, longitude], map.current.getZoom());
            firstCallRef.current = false;
        }
    } catch (error) {
        console.error('Erreur de géolocalisation:', error);
    }
};


    const [isPressed, setIsPressed] = useState(false);

    console.log(location);

    return (
       
  <div className="map-wrap">


            <div style={{ position: 'absolute', width: '100%', height: '100%' , display:'flex' }}>

                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        right: '3%',
                        top: '46%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                        borderWidth: '1px',
                        backgroundColor: isPressed ? colors.white : colors.accent,
                        height: 50,
                        width: 50,
                        borderRadius: '50%',
                        display: 'flex',
                        alignSelf: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'transform 0.1s, background-color 0.1s',
                        transform: isPressed ? 'scale(0.95)' : 'scale(1)',
                    }}
                    onMouseDown={() => setIsPressed(true)}
                    onMouseUp={() => setIsPressed(false)}
                    onMouseLeave={() => setIsPressed(false)}
                    onTouchStart={() => setIsPressed(true)}
                    onTouchEnd={() => setIsPressed(false)}
                    onTouchCancel={() => setIsPressed(false)}
                    onClick={getRealTimePositionFunc}
                >
                    <FaCrosshairs size={20} color={colors.black} />
                </div>
                

                <div
                    style={{
                        position: 'absolute',
                        alignSelf: 'center',
                        justifySelf: 'center',
                        bottom: 0,
                        top: 0,
                        right: 0,
                        left: 0,
                        zIndex: 1,
                        height: 50,
                        width: 50,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <PlusOutlined style={{ color: colors.black, marginLeft: '5px', fontSize: '12px' }} />
                </div>

            </div>



            <div ref={mapContainer} className="map" style={{ zIndex: 0 }} />


        </div >

    )
}

export default ClientHomeMap;


